export const draftChoiceTypes = ['select', 'multiselect'] as const;

export const requiredDraftChoiceIds = ['talking_heads', 'script_length', 'story_angle', 'editorial_edge'] as const;

export type DraftChoiceType = (typeof draftChoiceTypes)[number];

export type DraftChoiceOption = {
  value: string;
  label: string;
};

export type DraftChoice = {
  id: string;
  type: DraftChoiceType;
  label: string;
  helpText: string | null;
  required: boolean;
  options: DraftChoiceOption[];
  placeholder: string | null;
};

export type DraftOptionsResponse = {
  choices: DraftChoice[];
};

export type DraftAnswers = Record<string, string | string[]>;

export type DraftOptionsRequest = {
  idea: string;
};

export type DraftScriptRequest = {
  idea: string;
  choices: DraftChoice[];
  answers: DraftAnswers;
};

export type DraftScriptResponse = {
  title: string;
  logline: string;
  script: string;
};
